import { render, staticRenderFns } from "./evalidatePlace.vue?vue&type=template&id=afb67590&scoped=true&"
import script from "./evalidatePlace.vue?vue&type=script&lang=js&"
export * from "./evalidatePlace.vue?vue&type=script&lang=js&"
import style0 from "./evalidatePlace.vue?vue&type=style&index=0&id=afb67590&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb67590",
  null
  
)

export default component.exports